export default "__VITE_ASSET__792bb975__"